import { useNavigate, useParams } from 'react-router-dom';
import PartnerDetailsView from './PartnerDetailsView';

const PartnersView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const partnerId = Number(id);

    return (
            <PartnerDetailsView
                partnerId={partnerId}
                onEdit={() => navigate(`/partners/edit/${partnerId}`)}
                onCreateUser={() => navigate(`/admin/users/add?partnerId=${partnerId}`)}
            />
    );
}

export default PartnersView
